import { apiEncrypt, apiDecrypt } from './apiCrypto.js';

// Returns decrypted string, or the raw value if it was never encrypted (backward compat)
export async function secureGet(key) {
  const raw = localStorage.getItem(key);
  if (!raw) return null;
  return apiDecrypt(raw);
}

// Encrypts value and stores it. Existing plain-text values are overwritten on next write.
export async function secureSet(key, value) {
  if (value === null || value === undefined) {
    localStorage.removeItem(key);
    return;
  }
  const encrypted = await apiEncrypt(String(value));
  localStorage.setItem(key, encrypted);
}

export function secureRemove(key) {
  localStorage.removeItem(key);
}
